

















































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {validate} from "vee-validate";

import tippy from 'tippy.js';

@Component({})

export default class EditableInput extends Vue {

  @Prop({default:'',type: String}) value!:string;
  @Prop({default: false, type: Boolean}) editing!:boolean;
  @Prop({default: false, type: Boolean}) busy:boolean|undefined;
  @Prop({default: '<Enter text here>', type: String}) placeholder:string|undefined;
  @Prop({default:'', type: String}) rules!:string|Record<string, any>;

  localValue:string = '';
  failedRules:Record<string,string> = {};
  saving:boolean = false;

  public $refs!: {
    editableInput: HTMLInputElement,
    editableSelect: any
  };

  mounted(){
    this.localValue = this.value

    tippy('[data-tippy-content]', { arrow: true });
  }

  @Watch('value')
  onValueChange(newValue:string, oldValue:string){
    if (newValue !== oldValue){
      this.localValue = newValue;
    }
  }

  @Watch('editing')
  onEditingChange(newValue:string, oldValue:string){
    if (newValue){
      this.edit()
    }
    tippy('[data-tippy-content]', { arrow: true });
  }

  async validateField(){
    this.failedRules = {}
    const validationResult = await validate(this.localValue, this.rules);

    if (!validationResult.valid){
      this.failedRules = validationResult.failedRules
      this.getFocus()
      return false
    }
    return true
  }

  async save(){
    
    if (!await this.validateField())
      return
    

    this.$emit('edit', false)
    this.$emit('input',this.localValue)
    this.saving = false
  }

  cancel(){
    if (this.saving){
      return
    }
    this.failedRules={};
    this.localValue = this.value;
    this.$emit('edit', false)
  }

  toggleEdit(){
    this.$emit('edit', true);
  }

  async edit(){
    this.failedRules={};

    await Vue.nextTick();
    this.getFocus();
  }

  getFocus(){
    this.$refs.editableInput.focus()
  }
}

